import { useSearchParams } from 'react-router-dom';

export const usePaginationSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setCurrentPage = (page: number) =>
    setSearchParams((prev) => ({ ...prev, page }), { replace: true });

  const currentPage = parseInt(searchParams.get('page') || '');
  if (!currentPage) setCurrentPage(1);

  return {
    currentPage,
    setCurrentPage,
  };
};
